import React from 'react';
import { useNavigate } from 'react-router-dom';
import './style.css';
import PopupRegister from '../Signup/PopupRegister';
import { useState } from 'react';

function Card({ id, slug, image, title, excerpt, user, article_type }) {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const handleReadMore = (e) => {
    if (!user?.login) {
			e.preventDefault();
			setShowModal(true)
      return;
		}
     else if (user?.login && !user?.email_verified) {
			e.preventDefault();
			setShowModal(true);
      return
		}
    // Navigate to the article detail page using the slug
    navigate(`/article/${slug}`);
  };

  return (
    <div className='al-card'>
      <div className='al-card__imageWrap'>
        <img className='al-card__image' src={image} alt={title} />
        {article_type === 'breaking-news' && (
          <span className='al-card__badge al-card__badge--breaking'>
            🔴 Breaking News
          </span>
        )}
      </div>
      <h3 className='al-card__title'>{title}</h3>
      <p className='al-card__excerpt'>{excerpt}</p>

      
      <PopupRegister showModal={showModal} setShowModal={setShowModal} returnUrl={'/articles'}/>
      <button 
        type='button' 
        className='al-button al-button--cta' 
        onClick={handleReadMore}
      >
        {user?.login ? 'Read More' : 'Login or Free Sign Up to Read More'}
      </button>
    </div>
  );
}

export default Card;
